module.exports = __webpack_public_path__ + "static/media/police.dc9e0816.svg";